import { CAMPAINGS_ACTIONS_TYPES } from './campaigns-reducer.constants'

export const campaignsReducer = (state, { type, payload }) => {
  switch (type) {
    case CAMPAINGS_ACTIONS_TYPES.SET_TABLE_DATA:
      return {
        ...state,
        data: Array.isArray(payload.data) ? payload.data : [],
        search: payload.search || {},
        pagination: payload.pagination || {},
        loading: false,
        error: false,
        msLoaded: Date.now(),
      }
    case CAMPAINGS_ACTIONS_TYPES.SET_CAMPAIGN:
      return {
        ...state,
        campaign: payload,
        detailLoading: false,
      }
    case CAMPAINGS_ACTIONS_TYPES.SET_LOADING:
      return {
        ...state,
        error: false,
        loading: true,
      }
    case CAMPAINGS_ACTIONS_TYPES.SET_FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
        msLoaded: true,
      }

    case CAMPAINGS_ACTIONS_TYPES.SET_TABLE_SELECTION:
      return {
        ...state,
        tableSelection: [
          ...state.tableSelection.filter(
            (el) => state.data.map((item) => item.id).indexOf(el.id) === -1
          ),
          ...payload,
        ],
      }
    case CAMPAINGS_ACTIONS_TYPES.SET_DETAIL_LOADING:
      return {
        ...state,
        detailError: false,
        detailLoading: true,
      }
    case CAMPAINGS_ACTIONS_TYPES.SET_DETAIL_FAILURE:
      return {
        ...state,
        detailError: true,
        detailLoading: false,
      }
    // case CAMPAINGS_ACTIONS_TYPES.SET_EDIT_MODE:
    //   return {
    //     ...state,
    //     editMode: payload,
    //   }
    case CAMPAINGS_ACTIONS_TYPES.SET_CAMPAIGN_STATUS: {
      if (!Array.isArray(state.data) || !payload || payload.id === undefined) {
        return state
      }

      let newData = [...state.data]
      const rowIndex = newData.findIndex((row) => row && row.id === payload.id)

      if (rowIndex >= 0) {
        newData[rowIndex] = { ...state.data[rowIndex], activa: payload.state }
      }

      return {
        ...state,
        data: newData,
      }
    }
    default:
      throw new Error('unknown action')
  }
}
